import React, { createContext, useContext } from 'react';

const LiffLineContext = createContext({
  lineSub: null,
  liffReady: false,
});

export function LiffLineProvider({ lineSub, liffReady, children }) {
  return (
    <LiffLineContext.Provider value={{ lineSub: lineSub || null, liffReady: !!liffReady }}>
      {children}
    </LiffLineContext.Provider>
  );
}

export function useLiffLine() {
  return useContext(LiffLineContext);
}

export default LiffLineContext;
